/**
 * Title to Bloodstream Mapper Module
 * Handles the title mapper queue interface for mapping titles to Bloodstream (Gizmott)
 */
class TitleMapperBloodstream {
  static EL_PAGE = '#title_mapper_bloodstream_page';

  constructor() {
    this.selectedTitles = new Set();
    this.processingStatuses = new Map();
    this.statusCheckInterval = null;

    this.init();
  }

  /**
   * Initialize the title mapper
   */
  init() {
    console.log('=== INITIALIZING TITLE MAPPER BLOODSTREAM ===');
    console.log('Preview buttons found:', $('.preview-btn').length);
    console.log('Map buttons found:', $('.map-btn').length);
    console.log('CardModal available:', typeof window.CardModal);

    // Set up event listeners
    this.setupEventListeners();

    // Start status polling
    this.startStatusPolling();

    console.log('Title Mapper Bloodstream initialized');
  }

  /**
   * Set up all event listeners
   */
  setupEventListeners() {
    const self = this;

    // Select all checkbox
    $('#select-all-checkbox').on('change', function() {
      const isChecked = $(this).prop('checked');
      $('.title-checkbox').prop('checked', isChecked);
      self.updateSelectedCount();
    });

    // Individual checkboxes
    $('.title-checkbox').on('change', function() {
      self.updateSelectedCount();
    });

    // Select all button
    $('#select-all-btn').on('click', function() {
      $('#select-all-checkbox').prop('checked', true).trigger('change');
    });

    // Bulk map button
    $('#bulk-map-btn').on('click', function() {
      self.bulkMap();
    });

    // Preview buttons - navigate to preview page
    $('.preview-btn').on('click', function(e) {
      const titleId = $(this).data('id');
      window.location.href = `/admin/title-mapper-bloodstream/preview/${titleId}`;
    });

    // Map buttons
    $('.map-btn').on('click', function() {
      const titleId = $(this).data('id');
      self.mapTitle(titleId);
    });
  }

  /**
   * Update the count of selected titles
   */
  updateSelectedCount() {
    const count = $('.title-checkbox:checked').length;
    $('#selected-count').text(count);
    $('#bulk-map-btn').prop('disabled', count === 0);
  }

  /**
   * Map a title to Bloodstream
   * @param {number} titleId - The title ID to map
   * @param {object} options - Optional overrides (vanity_url, external_source_id, etc.)
   */
  mapTitle(titleId, options = {}) {
    const self = this;
    const $button = $(`.map-btn[data-id="${titleId}"]`);
    const $row = $button.closest('tr');
    const isUpdate = $button.text().includes('Update');

    const message = isUpdate
      ? 'Update this mapping?\n\nThis will modify the existing gizmott_videos record and push changes to Gizmott.'
      : 'Map this title to Bloodstream?\n\nThis will create a new gizmott_videos record and push data to Gizmott.';

    if (!confirm(message)) {
      return;
    }

    // Disable button and show spinner
    $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i>');

    // Update status badge
    this.updateStatusBadge(titleId, 'processing', 'Mapping...');

    // Prepare request payload
    const payload = {
      async: true,
    };

    // Add custom overrides if provided
    if (Object.keys(options).length > 0) {
      payload.overrides = options;
    }

    // Call API to map title
    $.ajax({
      url: `/api/titles/${titleId}/map-bloodstream`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(payload),
      dataType: 'json',
      success: function(response) {
        if (response.success) {
          self.showNotification('Title queued for mapping to Bloodstream', 'success');

          // Mark as processing
          self.processingStatuses.set(titleId, true);

          // Poll for completion
          self.pollTitleStatus(titleId);
        } else {
          self.showNotification('Error: ' + (response.error || 'Unknown error'), 'alert');
          $button.prop('disabled', false).html(`<i class="fas fa-cloud-upload-alt"></i> ${isUpdate ? 'Update' : 'Map'}`);
          self.updateStatusBadge(titleId, 'error', 'Error');
        }
      },
      error: function(xhr) {
        const errorMsg = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Failed to map';
        self.showNotification('Error: ' + errorMsg, 'alert');
        $button.prop('disabled', false).html(`<i class="fas fa-cloud-upload-alt"></i> ${isUpdate ? 'Update' : 'Map'}`);
        self.updateStatusBadge(titleId, 'error', 'Error');
      },
    });
  }

  /**
   * Bulk map selected titles
   */
  bulkMap() {
    const self = this;
    const titleIds = [];

    $('.title-checkbox:checked').each(function() {
      titleIds.push(parseInt($(this).val()));
    });

    if (titleIds.length === 0) {
      return;
    }

    if (!confirm(`Map ${titleIds.length} titles to Bloodstream?\n\nThis will create/update gizmott_videos records and push to Gizmott.`)) {
      return;
    }

    const $button = $('#bulk-map-btn');
    $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Mapping...');

    $.ajax({
      url: '/api/titles/bulk-map-bloodstream',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        title_ids: titleIds,
      }),
      dataType: 'json',
      success: function(response) {
        if (response.success) {
          const results = response.results;
          const queuedCount = results.queued.length;
          const alreadyProcessingCount = results.already_processing.length;
          const errorCount = results.errors.length;

          self.showNotification(
            `Bulk mapping initiated: ${queuedCount} queued, ${alreadyProcessingCount} already processing, ${errorCount} errors`,
            'success',
          );

          // Mark as processing
          results.queued.forEach(function(id) {
            self.processingStatuses.set(id, true);
            self.updateStatusBadge(id, 'processing', 'Mapping...');
          });

          // Uncheck all
          $('.title-checkbox').prop('checked', false);
          $('#select-all-checkbox').prop('checked', false);
          self.updateSelectedCount();

          $button.prop('disabled', false).html('<i class="fas fa-cloud-upload-alt"></i> Map Selected (<span id="selected-count">0</span>)');
        } else {
          self.showNotification('Error: ' + (response.error || 'Unknown error'), 'alert');
          $button.prop('disabled', false).html('<i class="fas fa-cloud-upload-alt"></i> Map Selected (<span id="selected-count">0</span>)');
        }
      },
      error: function() {
        self.showNotification('Error: Failed to bulk map', 'alert');
        $button.prop('disabled', false).html('<i class="fas fa-cloud-upload-alt"></i> Map Selected (<span id="selected-count">0</span>)');
      },
    });
  }

  /**
   * Update status badge for a title
   */
  updateStatusBadge(titleId, status, text) {
    const $badge = $(`.mapping-status-badge[data-title-id="${titleId}"]`);

    const labelClass =
      {
        processing: 'warning',
        completed: 'success',
        error: 'alert',
        unmapped: 'warning',
        mapped: 'success',
      }[status] || 'secondary';

    const icon =
      {
        processing: 'spinner fa-spin',
        completed: 'check-circle',
        error: 'exclamation-triangle',
        unmapped: 'question-circle',
        mapped: 'check-circle',
      }[status] || 'question-circle';

    $badge.html(`<span class="label ${labelClass}"><i class="fas fa-${icon}"></i> ${text}</span>`);
  }

  /**
   * Poll title status until complete
   */
  pollTitleStatus(titleId) {
    const self = this;
    let attempts = 0;
    const maxAttempts = 60; // 5 minutes (5-second intervals)

    const checkStatus = function() {
      attempts++;

      $.ajax({
        url: `/api/titles/${titleId}/bloodstream-status`,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
          if (response.success && response.data) {
            const isProcessing = response.data.is_processing;
            const result = response.data.result;

            if (!isProcessing && result) {
              // Processing complete
              self.processingStatuses.delete(titleId);

              if (result.success === false) {
                // Error
                self.updateStatusBadge(titleId, 'error', 'Failed');
                self.showNotification(`Title ${titleId} mapping failed: ${result.error}`, 'alert');

                // Re-enable map button
                const $button = $(`.map-btn[data-id="${titleId}"]`);
                $button.prop('disabled', false).html('<i class="fas fa-cloud-upload-alt"></i> Map');
              } else {
                // Success
                self.updateStatusBadge(titleId, 'mapped', 'Mapped');
                self.showNotification(
                  `Title ${titleId} mapped successfully! Gizmott Video ID: ${result.gizmott_video_id}`,
                  'success',
                );

                // Update button to "Update" and change to warning color
                const $button = $(`.map-btn[data-id="${titleId}"]`);
                $button.prop('disabled', false)
                  .removeClass('success')
                  .addClass('warning')
                  .html('<i class="fas fa-cloud-upload-alt"></i> Update');

                // Add Bloodstream link if vanity URL exists
                let bloodstreamUrl = null;
                if (result.vanity_url) {
                  const $buttonGroup = $button.parent('.button-group');
                  bloodstreamUrl = `https://bloodstreamtv.com/show-details/${result.vanity_url}`;

                  // Check if link doesn't already exist
                  if ($buttonGroup.find('a[target="_blank"]').length === 0) {
                    $buttonGroup.append(`
                      <a href="${bloodstreamUrl}"
                         target="_blank"
                         class="button small info"
                         title="View on Bloodstream">
                        <i class="fas fa-external-link-alt"></i>
                      </a>
                    `);
                  }
                }

                // Show go-live notification modal
                self.showGoLiveNotificationModal(titleId, result.gizmott_video_id, bloodstreamUrl);
              }
            } else if (attempts < maxAttempts) {
              // Still processing, check again
              setTimeout(checkStatus, 5000);
            } else {
              // Max attempts reached
              self.updateStatusBadge(titleId, 'error', 'Timeout');
              self.showNotification(`Title ${titleId} timed out. Check logs for details.`, 'warning');

              // Re-enable map button
              const $button = $(`.map-btn[data-id="${titleId}"]`);
              $button.prop('disabled', false).html('<i class="fas fa-cloud-upload-alt"></i> Map');
            }
          }
        },
        error: function() {
          if (attempts < maxAttempts) {
            setTimeout(checkStatus, 5000);
          }
        },
      });
    };

    // Start checking
    setTimeout(checkStatus, 5000);
  }

  /**
   * Start polling for status updates of processing titles
   */
  startStatusPolling() {
    const self = this;

    // Check every 10 seconds for any processing titles
    this.statusCheckInterval = setInterval(function() {
      if (self.processingStatuses.size > 0) {
        self.processingStatuses.forEach(function(value, titleId) {
          // Only poll if still marked as processing
          if (value) {
            self.pollTitleStatus(titleId);
          }
        });
      }
    }, 10000);
  }

  /**
   * Show notification toast
   */
  showNotification(message, type) {
    // Use Foundation Callout for notifications
    const calloutClass = type || 'primary';
    const $callout = $(`
            <div class="callout ${calloutClass}" style="position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px;">
                ${message}
                <button class="close-button" aria-label="Dismiss alert" type="button">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        `);

    $('body').append($callout);

    // Manual close button handler
    $callout.find('.close-button').on('click', function() {
      $callout.fadeOut(300, function() {
        $(this).remove();
      });
    });

    // Auto-close after 5 seconds
    setTimeout(function() {
      $callout.fadeOut(300, function() {
        $(this).remove();
      });
    }, 5000);
  }

  /**
   * Show go-live notification modal after successful mapping
   * @param {number} titleId - The mapped title ID
   * @param {number} gizmottVideoId - The Gizmott video ID
   * @param {string|null} bloodstreamUrl - The Bloodstream URL for the film
   */
  showGoLiveNotificationModal(titleId, gizmottVideoId, bloodstreamUrl) {
    const self = this;

    // Create modal if it doesn't exist
    if ($('#go-live-modal').length === 0) {
      const modalHtml = `
        <div id="go-live-modal-backdrop" class="modal-backdrop"></div>
        <div id="go-live-modal" class="card-modal large theme-dark">
          <div class="card-header">
            <div class="header-middle">
              <h3><i class="fas fa-check-circle" style="color: #4caf50;"></i> Title Published Successfully!</h3>
            </div>
            <button type="button" class="close-modal" aria-label="Close">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="card-body">
            <p class="mb-3">Your title has been published to Bloodstream and will go live according to the scheduled date.</p>

            <div id="go-live-bloodstream-link" class="mb-3" style="display: none;">
              <a href="" target="_blank" class="button info has-icon">
                <i class="fas fa-external-link-alt"></i> View on Bloodstream
              </a>
            </div>

            <hr style="border-color: rgba(255,255,255,0.1); margin: 20px 0;">

            <div class="mb-3">
              <label class="checkbox-label" style="display: flex; align-items: center; gap: 10px; cursor: pointer;">
                <input type="checkbox" id="send-go-live-email" checked style="width: auto; margin: 0;">
                <span>Email submitter when title goes live</span>
              </label>
            </div>

            <div id="go-live-message-wrapper">
              <label for="go-live-message"><strong>Custom message (optional):</strong></label>
              <p class="help-text mb-2" style="color: #888; font-size: 0.9em;">This message will be included in the go-live notification email sent to the submitter.</p>
              <textarea id="go-live-message" rows="4" placeholder="Congratulations! Your film is now available on Bloodstream..." style="width: 100%;"></textarea>
            </div>
          </div>
          <div class="card-footer" style="display: flex; justify-content: flex-end; gap: 10px;">
            <button type="button" id="confirm-go-live-settings" class="button success has-icon">
              <i class="fas fa-check"></i> Done
            </button>
          </div>
        </div>
        <style>
          #go-live-modal-backdrop {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            z-index: 100000;
          }
          #go-live-modal-backdrop.show { display: block; }
          #go-live-modal {
            display: none;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 100001;
            max-width: 600px;
            width: 90%;
          }
          #go-live-modal.show { display: block; }
          #go-live-modal .card-body { padding: 20px; }
          #go-live-modal .card-footer {
            padding: 15px 20px;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
          }
          #go-live-modal .checkbox-label:hover {
            background: rgba(255, 255, 255, 0.05);
            padding: 5px;
            margin: -5px;
            border-radius: 4px;
          }
        </style>
      `;
      $('body').append(modalHtml);

      // Set up modal event handlers
      $('#go-live-modal .close-modal').on('click', function() {
        self.hideGoLiveModal();
      });

      $('#go-live-modal-backdrop').on('click', function() {
        self.hideGoLiveModal();
      });

      $('#send-go-live-email').on('change', function() {
        if ($(this).is(':checked')) {
          $('#go-live-message-wrapper').slideDown(200);
        } else {
          $('#go-live-message-wrapper').slideUp(200);
        }
      });

      $('#confirm-go-live-settings').on('click', function() {
        const sendEmail = $('#send-go-live-email').is(':checked');
        const message = $('#go-live-message').val().trim();
        const videoId = $('#go-live-modal').data('gizmott-video-id');

        // Save settings via AJAX
        $.ajax({
          url: '/api/gizmott-videos/' + videoId + '/notification-settings',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            send_live_notification: sendEmail,
            live_notification_message: message,
          }),
          dataType: 'json',
          success: function(response) {
            if (response.success) {
              self.showNotification('Notification settings saved', 'success');
            } else {
              self.showNotification('Failed to save settings: ' + (response.error || 'Unknown error'), 'alert');
            }
          },
          error: function() {
            self.showNotification('Failed to save notification settings', 'alert');
          },
        });

        self.hideGoLiveModal();
      });
    }

    // Update modal content
    $('#go-live-modal').data('title-id', titleId);
    $('#go-live-modal').data('gizmott-video-id', gizmottVideoId);

    if (bloodstreamUrl) {
      $('#go-live-bloodstream-link').show().find('a').attr('href', bloodstreamUrl);
    } else {
      $('#go-live-bloodstream-link').hide();
    }

    // Reset form
    $('#send-go-live-email').prop('checked', true);
    $('#go-live-message').val('');
    $('#go-live-message-wrapper').show();

    // Show modal
    $('#go-live-modal').addClass('show');
    $('#go-live-modal-backdrop').addClass('show');
  }

  /**
   * Hide the go-live notification modal
   */
  hideGoLiveModal() {
    $('#go-live-modal').removeClass('show');
    $('#go-live-modal-backdrop').removeClass('show');
  }
}

// Make mapTitle available globally for modal
window.TitleMapperBloodstream = {
  instance: null,
  mapTitle: function(titleId, options) {
    if (this.instance && this.instance.mapTitle) {
      this.instance.mapTitle(titleId, options);
    }
  },
};

// Initialize title mapper when DOM is ready
;(function() {
  function initMapper() {
    if (document.querySelector(TitleMapperBloodstream.EL_PAGE) !== null) {
      const mapper = new TitleMapperBloodstream();
      window.sflow.titleMapperBloodstream = mapper;
      window.TitleMapperBloodstream.instance = mapper;
    }
  }

  // Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMapper);
  } else {
    initMapper();
  }
})();
